import { Injectable, Renderer2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HideFloatingLabelService {
  floatingLabelfunOne(
    useDataValue: boolean,
    datavalue: string | undefined,
    appPaymentsFloatingLabel: HTMLElement | null | undefined,
    eleNativeValue: unknown,
    placeHolderLabel: string | undefined,
    eleNative: unknown,
    labelvalue: string | undefined,
    renderer: Renderer2
  ) {
    if (useDataValue) {
      this.floatinglabelDataValueInvisible(
        datavalue,
        appPaymentsFloatingLabel,
        renderer
      );
    } else {
      this.floatinglabelElementRefInvisible(
        appPaymentsFloatingLabel,
        eleNativeValue,
        placeHolderLabel,
        eleNative,
        labelvalue,
        renderer
      );
    }
  }

  floatinglabelDataValueInvisible(
    datavalue: string | undefined,
    appPaymentsFloatingLabel: HTMLElement | null | undefined,
    renderer: Renderer2
  ) {
    if (
      datavalue === undefined ||
      datavalue === null ||
      datavalue.length === 0
    ) {
      renderer.addClass(appPaymentsFloatingLabel, 'invisible');
    }
  }

  floatinglabelElementRefInvisible(
    appPaymentsFloatingLabel: HTMLElement | null | undefined,
    eleNativeValue: unknown,
    placeHolderLabel: string | undefined,
    eleNative: unknown,
    labelvalue: string | undefined,
    renderer: Renderer2
  ) {
    if (!eleNativeValue) {
      renderer.addClass(appPaymentsFloatingLabel, 'invisible');
      this.elementRefPlaceholder(
        placeHolderLabel,
        eleNative,
        labelvalue,
        renderer
      );
    }
  }

  elementRefPlaceholder(
    placeHolderLabel: string | undefined,
    eleNative: unknown,
    labelvalue: string | undefined,
    renderer: Renderer2
  ) {
    if (placeHolderLabel) {
      renderer.setAttribute(eleNative, 'placeholder', placeHolderLabel.trim());
    }
    if (labelvalue && !placeHolderLabel) {
      renderer.setAttribute(eleNative, 'placeholder', labelvalue.trim());
    }
  }
}
